import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f15ab3fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-input" }
const _hoisted_2 = ["placeholder", "value", "aria-label"]
const _hoisted_3 = {
  key: 0,
  class: "search-input-form-icon"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_SearchInputAutoComplete = _resolveComponent("SearchInputAutoComplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "search-input-form",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("input", {
        ref: "input",
        type: "search",
        class: "search-input-form-field",
        placeholder: _ctx.$t('landing-page.search-all-works'),
        value: _ctx.searchValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInput($event.target.value))),
        onFocusin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focused = true)),
        "aria-label": _ctx.$t('landing-page.search-all-works')
      }, null, 40, _hoisted_2),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Spinner, {
            key: 1,
            class: "mx-1 mb-1",
            size: "sm"
          }))
        : _createCommentVNode("", true)
    ], 32),
    _createVNode(_component_SearchInputAutoComplete, {
      open: _ctx.focused && _ctx.options.length && _ctx.searchValue?.length >= _ctx.minLength,
      options: _ctx.options,
      activeIndex: _ctx.activeIndex,
      "onUpdate:activeIndex": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeIndex) = $event)),
      onAutoComplete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.completeValue($event)))
    }, null, 8, ["open", "options", "activeIndex"])
  ]))
}